
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/919b33af756e95b73a969b9744fc978f.jpg')`
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full">
        <div className="grid md:grid-cols-3 gap-12 items-center">
          <div className="md:col-span-2 text-white">
            <h1 className="text-6xl md:text-7xl font-bold mb-6 leading-tight">
              Sonríe con <br />
              <span className="bg-gradient-to-r from-sky-300 to-olive-400 bg-clip-text text-transparent">
                Confianza
              </span>
            </h1>
            <p className="text-xl md:text-2xl text-gray-100 mb-8 leading-relaxed max-w-2xl">
              Especialistas en ortodoncia avanzada. Transformamos sonrisas con los tratamientos más innovadores y efectivos del mercado.
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <button 
                onClick={() => scrollToSection('tipos')}
                className="flex items-center space-x-2 bg-olive-500 text-white px-8 py-4 rounded-full hover:bg-olive-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <span className="font-semibold">Conocer Tratamientos</span>
                <i className="ri-arrow-right-line"></i>
              </button>
              <button 
                onClick={() => scrollToSection('casos')}
                className="flex items-center space-x-2 bg-transparent border-2 border-white text-white px-8 py-4 rounded-full hover:bg-white hover:text-petrol-700 transition-all whitespace-nowrap cursor-pointer"
              >
                <span className="font-semibold">Ver Casos Reales</span>
              </button>
            </div>

            <div className="grid grid-cols-3 gap-8 max-w-2xl">
              <div>
                <div className="text-5xl font-bold text-sky-300 mb-2">15K+</div>
                <div className="text-gray-200 text-sm">Pacientes Satisfechos</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-sky-300 mb-2">25+</div>
                <div className="text-gray-200 text-sm">Años de Experiencia</div>
              </div>
              <div>
                <div className="text-5xl font-bold text-sky-300 mb-2">120+</div>
                <div className="text-gray-200 text-sm">Especialistas Certificados</div>
              </div>
            </div>
          </div>

          <div className="hidden md:block">
            <div className="relative">
              {/* Elemento eliminado */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
